import Vue from 'vue';
import PageLoading from './PageLoading';

// Components that are registered globaly.
[PageLoading].forEach(
  Component => {
    Vue.component(Component.name, Component).default;
  },
);
